import { render, staticRenderFns } from "./VuseSectionDefinition.vue?vue&type=template&id=70b3c49d&scoped=true"
import script from "./VuseSectionDefinition.vue?vue&type=script&lang=js"
export * from "./VuseSectionDefinition.vue?vue&type=script&lang=js"
import style0 from "./VuseSectionDefinition.vue?vue&type=style&index=0&id=70b3c49d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b3c49d",
  null
  
)

export default component.exports